import BaseListItem from '@material-ui/core/ListItem'

const ListItem = BaseListItem

export default ListItem
